import * as actionTypes from "./actionTypes";

export const setLoading = (isLoading, eventName) => {
    return {
        type: actionTypes.SET_LOADING,
        payload: {
            isLoading,
            eventName,
        },
    };
};

export const setLoadingGlobal = (isLoading) => {
    return {
        type: actionTypes.SET_LOADING_GLOBAL,
        payload: {
            isLoading,
        },
    };
};
